/**
 * @generated SignedSource<<b9012599c03999d99377327c2f8c4051>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateProjectPortalConfigInput = {
  psaProjectId: string;
  legacyPsaProjectId?: string | null;
  showInClientPortal?: boolean | null;
  portalPhaseStatusVisible?: boolean | null;
  psaClientExternalId?: string | null;
  clientName?: string | null;
  projectName?: string | null;
  projectStatus?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateProjectPortalConfigMutation$variables = {
  input: UpdateProjectPortalConfigInput;
};
export type updateProjectPortalConfigMutation$data = {
  readonly updateProjectPortalConfig: {
    readonly project: {
      readonly id: string;
      readonly portalConfig: {
        readonly showInClientPortal: boolean | null;
        readonly portalPhaseStatusVisible: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type updateProjectPortalConfigMutation = {
  variables: updateProjectPortalConfigMutation$variables;
  response: updateProjectPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateProjectPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectPortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showInClientPortal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portalPhaseStatusVisible",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "990fba004c3dc008e0a0148da6f1568b",
    "id": null,
    "metadata": {},
    "name": "updateProjectPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectPortalConfigMutation(\n  $input: UpdateProjectPortalConfigInput!\n) {\n  updateProjectPortalConfig(input: $input) {\n    project {\n      id\n      portalConfig {\n        showInClientPortal\n        portalPhaseStatusVisible\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6777e04c05a12646ca921b5d9d80ca4";

export default node;
